const subCategories = {
  list: {
    subCategoriesList: "Sub Categories List",
    subCategory: "Sub Category",
    subCategories: "Sub Categories",
    products: "Products",
    tableHeader: {
      subCategoryName: "Sub Category Name",
      description: "Description",
      category: "Category",
      numberOfProducts: "Number Of Products",
      actions: "Actions"
    },
    filters: {
      categories: "Categories",
      placeholders: {
        categories: "Search by category name"
      }
    },
    addMoreSubCategories: "Add Sub Category",
    noSubCategoriesFound: "You haven’t added any Sub categories yet.",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search by Sub Category Name"
  },
  addSubcategory: {
    addSubCategory: "Add Sub Category",
    editSubCategory: "Edit Sub Category",
    addMore: "Add More",
    subCategoryInfo: "Sub Category Info",
    specificationsSuggestions: "Specifications Suggestions",
    labels: {
      adminImage: "Sub Category Image",
      websiteImage: "Sub Category Cover",
      category: "Category",
      subCategoryName: "Sub Category Name",
      subCategoryDescription: "Sub Category Description",
      speicificationName: "Specification Name"
    },
    placeholders: {
      category: "Select a category",
      subCategoryName: "Enter Sub category name",
      subCategoryDescription: "Enter Sub category description",
      speicificationName: "Enter specification name"
    }
  },
  subCategoryDetails: {
    subCategoryDetailsTitle: "Sub Category Details",
    products: "Products",
    product: "Product",
    noProductsFound: "There is no products found",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search By Product name or Exporter name",
    tableHeader: {
      product: "Product",
      exporterName: "Exporter Name",
      country: "Country",
      publishingDate: "Publishing Date"
    },
    filter: {
      countries: "Countries",
      searchPlaceholders: "Search by Exporter Country"
    }
  },
  deleteSubCategory: {
    content: "Delete",
    confirmationContent:
      "Are you sure you want to delete this Sub Category ?",
    subConfirmationContent: "This action cannot be undone."
  }
};

export default subCategories;
